import { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function StorePricing() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/store/me").then((r) => setP(r.data.pricing || {})); }, []);
  const save = async () => {
    try { await api.patch("/store/pricing", p); toast.success("Pricing saved"); } catch (e) { toast.error(formatError(e)); }
  };
  if (!p) return null;
  return (
    <div className="p-4 sm:p-6 md:p-8 space-y-6" data-testid="store-pricing-page">
      <div><h1 className="font-display text-3xl font-bold tracking-tight">Pricing</h1><p className="text-slate-500">Rates the public print page will use</p></div>
      <Card className="border-slate-200 max-w-2xl">
        <CardHeader><CardTitle className="font-display">Per-page rates</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><Label>B&W per page (₹)</Label><Input type="number" step="0.1" value={p.bw_per_page} onChange={(e) => setP({ ...p, bw_per_page: +e.target.value })} data-testid="pricing-bw" /></div>
            <div><Label>Colour per page (₹)</Label><Input type="number" step="0.1" value={p.color_per_page} onChange={(e) => setP({ ...p, color_per_page: +e.target.value })} data-testid="pricing-color" /></div>
            <div><Label>Duplex discount (%)</Label><Input type="number" step="1" value={p.duplex_discount_pct} onChange={(e) => setP({ ...p, duplex_discount_pct: +e.target.value })} data-testid="pricing-duplex" /></div>
            <div><Label>Min order (₹)</Label><Input type="number" step="1" value={p.min_order_amount} onChange={(e) => setP({ ...p, min_order_amount: +e.target.value })} data-testid="pricing-min" /></div>
            <div><Label>GST (%)</Label><Input type="number" step="0.1" value={p.gst_pct} onChange={(e) => setP({ ...p, gst_pct: +e.target.value })} data-testid="pricing-gst" /></div>
          </div>
          <Button onClick={save} className="bg-orange-500 hover:bg-orange-600" data-testid="save-pricing">Save pricing</Button>
        </CardContent>
      </Card>
    </div>
  );
}
